import apiClient from '@/shared/lib/apiClient';
import type { Agreement } from '../types';

export const agreementsService = {
  getAll: (): Promise<Agreement[]> =>
    apiClient.get<Agreement[]>('/agreements').then((res) => res.data),
};
